import reportPacksDevelopmentDefaultOn from './reportPacksDevelopmentDefault';

const LOCAL_OVERRIDE_KEY = 'reportPacks';

/**
 * LaunchDarkly key: `ReportPacks`.
 * ON = dashboard Export opens server PDF/XLSX + delivery panel.
 * OFF = client Kendo export (`PreviewModal`).
 *
 * Checks both casings — the LD React SDK camelCases keys by default (`reportPacks`).
 *
 * Resolution order:
 *   1. `localStorage.reportPacks` when set (`'true'` / `'false'`) — wins over LD for local testing
 *   2. LaunchDarkly when defined
 *   3. In `development`, default **on** so local work against blox-bi does not need LD setup
 *   4. Otherwise **off**
 *
 *   localStorage.setItem('reportPacks', 'false')  // force Kendo export locally
 *   localStorage.removeItem('reportPacks')        // back to dev default (on)
 */
export const isReportPacksEnabled = (flags?: {
  ReportPacks?: boolean;
  reportPacks?: boolean;
}): boolean => {
  try {
    const override = window.localStorage.getItem(LOCAL_OVERRIDE_KEY);
    if (override !== null) return override === 'true';
  } catch {
    // localStorage can throw in private-browsing / sandboxed contexts.
  }

  const ldValue = flags?.ReportPacks ?? flags?.reportPacks;
  if (ldValue !== undefined) return Boolean(ldValue);

  if (reportPacksDevelopmentDefaultOn()) return true;

  return false;
};

export default isReportPacksEnabled;
